import { CaptionLabelProps, DayPicker } from "react-day-picker";
import es from "date-fns/locale/es";
import "./PlanificationAssistance.scss";

interface MonthPickerProps {
	monthIndex: number;
	selectedDays: Date[];
	setSelectedDays: (days: Date[]) => void;
	isLaboralDay: boolean;
	isAdmin: boolean;
	dayOffModifier: Date[];
	dayModifier: Date[];
	selectedYear: number;
}

const actualYear = new Date().getFullYear();

const DayOffModifierStyle = {
	backgroundColor: "#B78DB7",
	color: "white",
};

const DayModifierStyle = {
	backgroundColor: "#62098C",
	color: "white",
};

const MonthPicker: React.FC<MonthPickerProps> = ({
	monthIndex,
	selectedDays,
	setSelectedDays,
	isLaboralDay,
	isAdmin,
	dayOffModifier,
	dayModifier,
	selectedYear,
}) => (
	<DayPicker
		className="month-picker-days"
		mode="multiple"
		locale={{
			...es,
			options: {
				...es.options,
				weekStartsOn: 0,
			},
		}}
		defaultMonth={new Date(selectedYear, monthIndex)}
		month={new Date(selectedYear, monthIndex)}
		selected={selectedDays}
		onSelect={isAdmin ? (days) => setSelectedDays(days ?? []) : undefined}
		disableNavigation
		modifiers={{
			dayOffModifier,
			dayModifier,
		}}
		modifiersClassNames={{
			dayOffModifier: isLaboralDay
				? "month-picker-no-laboral-day"
				: "month-picker-laboral-day",
			dayModifier: isLaboralDay ? "month-picker-laboral-day" : "month-picker-no-laboral-day",
		}}
		hideNavigation
		hideWeekdays
		fixedWeeks
	/>
);

export default MonthPicker;
